import { Types } from '@store/types';

const initialState = { newMessage: {}, entityIdList: [], mentionedData: {} };

const ChatReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.NEW_INCOMING_MESSAGE_FAILURE:
			return state;
		case Types.NEW_INCOMING_MESSAGE_SUCCESS:
			return { ...state, newMessage: action.payload };
		case Types.NEW_INCOMING_MESSAGE_IN_LIST_PAGE:
			return { ...state, entityIdList: [...state.entityIdList, action.payload] };
		case Types.STORE_UNREAD_MENTION:
			return { ...state, mentionedData: action.payload };
		case Types.CLEAR_ALL_CHATS:
			return { ...state, newMessage: {}, entityIdList: [] };
		default:
			return state;
	}
};

export default ChatReducer;
